import styled from 'styled-components';

export const Page = styled.div`
  display: flex;
  height: calc(100% - ${(p) => p.theme.scale(3.5)});
`;
